import styled from '@emotion/styled';
import { Alert, ButtonGroup, colors } from '@ui-components/neo.tax';

export const HighlightText = styled.span<{ bold?: boolean }>(
  {
    color: colors.blue[500],
  },
  ({ bold }) => bold && { fontWeight: 500 },
);

export const StyledButtonGroup = styled(ButtonGroup)({
  '.button-group-option': {
    minWidth: 103,
  },
}) as typeof ButtonGroup;

export const FormItemFactoryContainer = styled.div``;

export const StyledAlertForCard = styled(Alert)({
  boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
});
